import React from "react";
import { ReactComponent as SVGLogoAlyPlus } from "assets/img/aly_plus_dark_logo.svg";
import working from "assets/img/working.png";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import "styles/system-maintenance.scss";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isBcerto } from "utils";

import * as authAction from 'actions/auth-action';

const SystemMaintenanceScreen = (props) => {
  const { logoutAction } = props;
  const navigate = useNavigate();


  const goBack = () => {
    logoutAction();
    navigate('/auth/login');
  }

  return (
    <div className="container" style={{ "--brand-main": isBcerto ? "#092f1a" : "#33425C" }}>
      <div className="wrapper">
        <div className="content">
          <SVGLogoAlyPlus width={96} height={40} />
          <h1 className="title">
            Estamos em manutenção...
          </h1>
          <p className="subtitle">
              Previsão de retorno em alguns instantes.
          </p>
          <Button
            block
            type="default"
            onClick={goBack}
            icon={<ArrowLeftOutlined />}
            style={{
              borderRadius: "40px",
              textAlign: "center",
              color: isBcerto ? "#092f1a" : "#33425c",
              borderColor: isBcerto ? "#092f1a" : "#33425c",
              borderWidth: "2px",
            }}
          >
            Voltar
          </Button>
        </div>
        <img
          src={working}
          alt="manutencao"
          className="image"
        />
      </div>
    </div>
  );
}


const mapStateToProps = (state) => ({
  login: state.authReducer.loginReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    ...authAction,
  },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SystemMaintenanceScreen);
